import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    resources: {
      en: {
        translation: {
          "smart_bots": "Smart Bots",
          "see_dashboard_options": "See your dashboard options.",
          "sidenav_type": "Sidenav Type",
          "choose_sidenav": "Choose between 2 different sidenav types.",
          "transparent": "Transparent",
          "opaque": "Opaque",
          "navbar_fixed": "Navbar Fixed",
          "dark_light": "Dark/Light",
          "toggle_dark_light": "Toggle Dark/Light",
          "language": "Language",
          "switch_to_setswana": "Switch to Setswana 🇧🇼",
          "switch_to_english": "Switch to English 🇬🇧",
          "todays_revenue": "Today's Revenue",
          "todays_users": "Today's Users",
          "new_clients": "New Clients",
          "total_sales": "Total Sales",
          "active_users": "Active Users",
          "sales_overview": "Sales Overview",
          "projects": "Projects",
          "companies": "Companies",
          "members": "Members",
          "budget": "Budget",
          "completion": "Completion",
          "orders_overview": "Orders Overview",
          "active_deliveries": "Active Deliveries",
          "smart_lockers_online": "Smart Lockers Online",
          "failed_deliveries": "Failed Deliveries",
          "active_support_tickets": "Active Support Tickets",
          "welcome_back": "Welcome Back",
          "enter_email_password": "Enter your email and password to sign in",
          "email": "Email",
          "your_email": "Your email address",
          "password": "Password",
          "your_password": "Your password",
          "remember_me": "Remember me",
          "sign_in": "Sign In",
          "dont_have_account": "Don't have an account?",
          "sign_up": "Sign Up",
          "smart": "Smart",
          "bots": "Bots",
          "welcome": "Welcome!",
          "use_forms": "Use these awesome forms to login or create a new account for your project for free.",
          "name": "Name",
          "your_full_name": "Your full name",
          "already_have_account": "Already have an account?",
          "dashboard": "Dashboard",
          "feedback": "Feedback",
          "contact_us": "Contact Us",
          "tables": "Tables",
          "billing": "Billing",
          "account_pages": "ACCOUNT PAGES",
          "profile": "Profile",
       

        }
      },
      tn: {
        translation: {
          "smart_bots": "Smart Bots",
          "see_dashboard_options": "Leba mekgwa e e farologang e o ka e dirisang.",
          "sidenav_type": "Sidenav Type",
          "choose_sidenav": "Tlhopha magareng ga mefuta e le mebedi e e farologaneng ya sidenav",
          "transparent": "Transparent",
          "opaque": "Opaque",
          "navbar_fixed": "Navbar Fixed",
          "dark_light": "Dark/Light",
          "toggle_dark_light": "Toggle Dark/Light",
          "language": "Teme",
          "switch_to_setswana": "Fetolela ko Setswaneng 🇧🇼",
          "switch_to_english": "Fetolela ko Sekgoweng 🇬🇧",
          "todays_revenue": "Madi a Gompieno",
          "todays_users": "Badiri ba Gompieno",
          "new_clients": "Bareki ba Basa",
          "total_sales": "Thekiso Yotlhe",
          "active_users": "Badiri ba Sebaka",
          "sales_overview": "Thekiso Yotlhe",
          "active_deliveries": "Dithoto",
          "smart_lockers_online": "Polekelo",
          "failed_deliveries": "",
          "active_support_tickets": "",
          "projects": "Projects",
          "companies": "Dikompone",
          "members": "Maloko",
          "budget": "Moalo",
          "completion": "Phethogo",
          "orders_overview": "Di Ordara Tsotlhe",
          "welcome_back": "Re a go amogela",
          "enter_email_password": "Tsenya email le password go tsena",
          "email": "Email",
          "your_email": "Aterese ya gago ya email",
          "password": "Password",
          "your_password": "Password ya gago",
          "remember_me": "Gakologelwa ",
          "sign_in": "TSENA",
          "dont_have_account": "Ga o na akhaonte?",
          "sign_up": "Dira Akhaonte",
          "smart": "Smart",
          "bots": "Bots",
          "welcome": "Rea go amogela!",
      "use_forms": "Dirisa fomo e go tsena kana go dira akhaonte e ntsha",
      "name": "Leina",
      "your_full_name": "Leina la gago le le feletseng",
      "already_have_account": "O na le akhaonto?",
      "dashboard": "Dikarolo",
      "feedback": "Dikakgelo",
      "contact_us": "Buwa le Rona",
      "tables": "Ditafole",
      "billing": "Tsa Madi",
      "account_pages": "DI AKHAONTE",
      "profile": "Akhaonte ka Botlalo",
        }
      }
    }
  });

export default i18n;
